import SvgIcon from "@mui/material/SvgIcon";
import { makeStyles } from "@mui/styles";
import { memo } from "react";

const useStyles = makeStyles(({ typography }) => ({
  icon: {
    width: typography.pxToRem(120),
    height: typography.pxToRem(120),
    fill: "none",
  },
}));

export const QuantumLogoIcon = memo(() => {
  const styles = useStyles();

  return (
    <SvgIcon
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      className={styles.icon}
    >
      <circle cx="60" cy="60" r="60" fill="url(#paint0_linear)" />
      <circle
        cx="60"
        cy="60"
        r="56.6"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="2"
      />
      <path
        d="M57.3407 33.3C71.1865 33.3 81.5192 43.6448 81.5192 57.5069C81.5192 65.7719 77.7147 72.8069 71.6386 77.0169L66.9067 72.092C71.5589 69.0664 74.4241 63.774 74.4241 57.5069C74.4241 47.5069 67.329 40.1276 57.3407 40.1276C47.5591 40.1276 40.3262 47.5069 40.3262 57.5069C40.3262 67.3689 47.5591 74.8172 57.3407 74.8172C58.4144 74.8172 59.4546 74.7312 60.4562 74.5653L65.1936 80.1276C68.3497 82.7608 72.1336 86.7765 77.8631 87.1361L78.695 87.162C81.657 87.162 84.4813 86.6793 85.9967 86.0586L86.8233 91.9896C85.0323 92.6103 81.7948 93.3 78.2128 93.3C67.0535 93.3 60.5783 83.0931 57.2718 81.5758C43.6327 81.5069 33.3 71.231 33.3 57.5069C33.3 43.6448 43.6327 33.3 57.3407 33.3Z"
        fill="white"
      />
      <path
        d="M79.6981 76.8199V76.8299H80.7539V76.8149C80.7539 76.0679 81.3466 75.5001 82.1335 75.5001C82.8806 75.5001 83.4583 76.0081 83.4583 76.6456C83.4583 77.2084 83.2292 77.5869 82.3526 78.4983L79.7578 81.143V81.9H84.6735V80.9587H81.2619V80.9338L83.0599 79.1259C84.1108 78.0501 84.559 77.4275 84.559 76.5908C84.559 75.4503 83.538 74.5787 82.1684 74.5787C80.739 74.5787 79.6981 75.525 79.6981 76.8199Z"
        fill="white"
      />
      <path
        d="M86.4466 81.9548C86.8102 81.9548 87.099 81.6659 87.099 81.3023C87.099 80.9388 86.8102 80.6499 86.4466 80.6499C86.083 80.6499 85.7941 80.9388 85.7941 81.3023C85.7941 81.6659 86.083 81.9548 86.4466 81.9548Z"
        fill="white"
      />
      <path
        d="M90.9041 82.0345C92.6273 82.0345 93.6384 80.5852 93.6384 78.2941C93.6384 76.0181 92.6224 74.5787 90.9041 74.5787C89.1908 74.5787 88.1599 76.023 88.1599 78.2991C88.1599 80.5901 89.1809 82.0345 90.9041 82.0345ZM90.9041 81.0981C89.8781 81.0981 89.2904 80.0323 89.2904 78.2991C89.2904 76.5908 89.8881 75.515 90.9041 75.515C91.9201 75.515 92.5128 76.5858 92.5128 78.2991C92.5128 80.0373 91.9301 81.0981 90.9041 81.0981Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0"
          y1="0"
          x2="120"
          y2="120"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A90034" />
          <stop offset="1" stopColor="#DC0032" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});
